import { useOrderById } from "@jasper/use-cases";
import {
  Avatar,
  Button,
  Divider,
  Grid,
  Group,
  Stepper,
  UnstyledButton,
} from "@mantine/core";
import { IconHome, IconX } from "@tabler/icons-react";
import { useNavigate, useParams } from "react-router-dom";

export const OrderStepsEnum = {
  orderInfo: "order-info",
  products: "products",
  summary: "summary",
} as const;

export type OrderSteps = (typeof OrderStepsEnum)[keyof typeof OrderStepsEnum];

export const ORDER_STEPS: OrderSteps[] = [
  "order-info",
  "products",
  "summary",
] as const;

interface Props {
  activeStep: (typeof ORDER_STEPS)[number];
}

export const OrderStepper = ({ activeStep }: Props) => {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const getUrlFromIndex = ({
    stepIndex,
    orderId,
  }: {
    stepIndex: number;
    orderId: string;
  }) => {
    switch (stepIndex) {
      case 0:
        return `/orders/${orderId}/configure/order-info`;
      case 1:
        return `/orders/${orderId}/configure/products`;
      case 2:
        return `/orders/${orderId}/configure/summary`;
      default:
        throw new Error("Unknown step index");
    }
  };

  const { order } = useOrderById({
    orderId: orderId!,
  });

  if (!orderId) {
    return null;
  }

  const handleClose = () => {
    navigate("/");
  };

  return (
    <Grid w="100%" align="center">
      <Grid.Col span={4}>
        <Group>
          <UnstyledButton aria-label="Accueil" onClick={handleClose}>
            <IconHome />
          </UnstyledButton>
          <Divider orientation="vertical" />
          <Button
            variant="subtle"
            leftSection={<IconX />}
            onClick={handleClose}
          >
            Enregistrer & fermer
          </Button>
        </Group>
      </Grid.Col>
      <Grid.Col span={4}>
        <Group justify="center">
          <Stepper
            variant="flow"
            active={ORDER_STEPS.indexOf(activeStep)}
            onStepClick={(stepIndex: number) => {
              navigate(
                getUrlFromIndex({
                  stepIndex: stepIndex,
                  orderId: orderId,
                })
              );
            }}
            allowNextStepsSelect={false}
          >
            <Stepper.Step label="Patient" />
            <Stepper.Step label="Produits" />
            <Stepper.Step label="Commande" />
          </Stepper>
        </Group>
      </Grid.Col>
      <Grid.Col span={4}>
        <Group justify="flex-end">
          {order?.dentist && (
            <Avatar
              color="brand"
              name={`${order.dentist.firstName} ${order.dentist.lastName}`}
              alt={`${order.dentist.firstName} ${order.dentist.lastName}`}
              radius="xl"
            />
          )}
        </Group>
      </Grid.Col>
    </Grid>
  );
};
